module.exports = __webpack_public_path__ + "img/Bodice-Back-Ja-Kj-Ld.b8aadf08.png";